export default function QuoteCTA() {
  return (
    <section id="quote" className="py-20 px-4 bg-gradient-to-br from-amber-500 to-amber-600 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">견적 문의</h2>
        <p className="text-xl text-white/90 mb-10 leading-relaxed">
          목형 제작부터 레이저 가공까지<br className="md:hidden" />
          전문가와 상담하세요
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-10">
          <a 
            href="tel:02-2263-8248"
            className="flex items-center gap-3 bg-white hover:bg-slate-50 text-slate-900 px-10 py-5 rounded-lg text-xl font-bold transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap"
          >
            <i className="ri-phone-fill text-2xl text-amber-500"></i>
            <div className="text-left">
              <div className="text-xs text-slate-600 font-normal">재기목형 대표전화</div>
              <div>02-2263-8248</div>
            </div>
          </a>
          
          <a 
            href="tel:02-2261-2017"
            className="flex items-center gap-3 bg-slate-800 hover:bg-slate-900 text-white px-10 py-5 rounded-lg text-xl font-bold transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap"
          >
            <i className="ri-phone-fill text-2xl text-amber-400"></i>
            <div className="text-left">
              <div className="text-xs text-slate-300 font-normal">뉴테크 레이저가공</div>
              <div>02-2261-2017</div>
            </div>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-white">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <i className="ri-mail-line text-3xl mb-3"></i>
            <div className="text-sm mb-1 opacity-90">이메일 문의</div>
            <a href="mailto:jk8248@hanmail.net" className="font-semibold hover:text-amber-200 transition-colors">jk8248@hanmail.net</a>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <i className="ri-printer-line text-3xl mb-3"></i>
            <div className="text-sm mb-1 opacity-90">팩스</div>
            <div className="font-semibold">02-2263-3616</div>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
            <i className="ri-time-line text-3xl mb-3"></i>
            <div className="text-sm mb-1 opacity-90">상담 시간</div>
            <div className="font-semibold">평일 09:00 - 18:00</div>
          </div>
        </div>
      </div>
    </section>
  );
}
